import { tv } from "tailwind-variants"
import { classNames } from "../../utils/classNames"
import { Button, type ButtonProps } from "../Button"

export type ToggleButtonProps = Omit<ButtonProps, "variant" | "href"> & {
  checked?: boolean
}

const toggleButtonVariants = tv({
  base: "hover:bg-bg-additional-1",
  variants: {
    checked: {
      // Override existing button borders
      true: "!border-text-primary bg-bg-additional-1",
    },
  },
})

export function ToggleButton({
  className,
  checked,
  ...rest
}: ToggleButtonProps) {
  return (
    <Button
      aria-checked={checked}
      className={classNames(toggleButtonVariants({ checked }), className)}
      role="checkbox"
      variant="secondary"
      {...rest}
    />
  )
}
